import type { FC } from 'react';

import { Skeleton } from '@/ui/components/skeleton/skeleton';

import { PlotSection } from '../plots/plot-section';

/**
 * A placeholder skeleton that mimics the table layout in OverviewTable.
 */
export const OverviewTableSkeleton: FC = () => {
  const columns = 8;
  const rows = 5;

  return (
    <PlotSection sectionName="Overview Table">
      <div className="w-full space-y-2">
        {/* Table header skeleton */}
        <div className="flex justify-around bg-gray-100 py-2">
          {Array.from({ length: columns }).map((_, i) => (
            <Skeleton key={i} className="h-6 w-20" />
          ))}
        </div>

        {/* Table body skeleton */}
        {Array.from({ length: rows }).map((_, rowIdx) => (
          <div key={rowIdx} className="flex justify-around py-2">
            {Array.from({ length: columns }).map((_, colIdx) => (
              <Skeleton key={colIdx} className="h-4 w-20" />
            ))}
          </div>
        ))}

        {/* Fine print placeholders */}
        <ul className="ml-4 mt-2 space-y-1 text-xs text-gray-400">
          <li className="flex gap-2">
            <span className="w-4 text-right">* </span>
            <Skeleton className="h-3 w-48" />
          </li>
          <li className="flex gap-2">
            <span className="w-4 text-right">**</span>
            <Skeleton className="h-3 w-60" />
          </li>
        </ul>
      </div>
    </PlotSection>
  );
};
